// const conf = {
//   jobintelpro_base_url: process.env.REACT_APP_JOBINTELPRO_API_URL,
//   whatsapp_url: process.env.REACT_APP_WHATSAPP_URL,
//   telegram_url: process.env.REACT_APP_TELEGRAM_URL,
// };

// export default conf;

const conf = {
  appwrite_url: String(process.env.REACT_APP_APPWRITE_URL),
  appwrite_project_id: String(process.env.REACT_APP_APPWRITE_PROJECT_ID),
  appwrite_database_id: String(process.env.REACT_APP_APPWRITE_DATABASE_ID),
  appwrite_jobs_collection_id: String(
    process.env.REACT_APP_APPWRITE_JOBS_COLLECTION_ID
  ),
  appwrite_subscription_collection_id: String(
    process.env.REACT_APP_APPWRITE_SUBSCRIPTION_COLLECTION_ID
  ),
  appwrite_savedjobs_collection_id: String(
    process.env.REACT_APP_APPWRITE_SAVEDJOBS_COLLECTION_ID
  ),
  appwrite_hackathon_collection_id: String(
    process.env.REACT_APP_HACKATHON_COLLECTION_ID
  ),
  appwrite_blogs_collection_id: String(
    process.env.REACT_APP_BLOG_COLLECTION_ID
  ),
  appwrite_prompt_function_id: String(
    process.env.REACT_APP_APPWRITE_PROMPT_FUNCTION_ID
  ),
  whatsapp_url: process.env.REACT_APP_WHATSAPP_URL,
  telegram_url: process.env.REACT_APP_TELEGRAM_URL,
  instagram_url: process.env.REACT_APP_INSTAGRAM_URL,
  linkedin_url: process.env.REACT_APP_LINKEDIN_URL,
  twitter_url: process.env.REACT_APP_TWITTER_URL,
  phone_number: process.env.REACT_APP_PHONE_NUMBER,
  email_id: process.env.REACT_APP_EMAIL,
};

export default conf;
